import map from 'lodash/map'
import React, { FC } from 'react'
import styled from 'styled-components'

import { FooterElement, SectionTitle } from '@Components/Footer/styled'
import { Link } from '@Components/Link'
import { NavigationEvent } from '@Events/Navigation'
import { up } from '@Globals/Style/breakpoints'
import { useTranslation } from '@Globals/Translations'
import { CustomerSupportData, useCustomerSupportData } from '@Globals/useCustomerSupportData'

const CustomerSupportLink: FC<CustomerSupportData> = (
  {
    destPageType,
    id,
    link,
    newTab,
    title,
  }: CustomerSupportData,
) => (
  <li key={id} className="link">
    <Link
      event={new NavigationEvent({
        attributes: {
          dest_page_type: destPageType,
          dest_page_type_id: id,
          source_id: 'footer_customer_support',
        },
        eventName: 'nav_link_click',
      })}
      href={link}
      rel={newTab ? 'noopener noreferrer' : undefined}
      target={newTab ? '_blank' : undefined}
    >
      {title}
    </Link>
  </li>
)

const StyledCustomerSupport = styled(FooterElement)`
  order: 3;

  ${up('tablet')} {
    order: 5;
  }

  ${up('desktop')} {
    order: 4;
  }

  li a {
    padding: 5px 0;
  }

  div {
    cursor: pointer;
  }

  .link {
    a {
      display: block;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`

export const CustomerSupport: FC = () => {
  const { t } = useTranslation()
  const customerSupportData = useCustomerSupportData()

  return (
    <StyledCustomerSupport>
      <Link href="/info">
        <SectionTitle>{t('footer:CUSTOMER_SUPPORT')}</SectionTitle>
      </Link>
      <ul>
        {map(customerSupportData, CustomerSupportLink)}
      </ul>
    </StyledCustomerSupport>
  )
}
